export const PACKAGE_VERSION = "0.17.4";
